import React from "react";

const SidebarIcon = () => {
  return (
    <div>
      <svg
        width="20"
        height="17"
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.25 0.25H1.75C1.35218 0.25 0.970644 0.408035 0.68934 0.68934C0.408035 0.970644 0.25 1.35218 0.25 1.75V15.25C0.25 15.6478 0.408035 16.0294 0.68934 16.3107C0.970644 16.592 1.35218 16.75 1.75 16.75H18.25C18.6478 16.75 19.0294 16.592 19.3107 16.3107C19.592 16.0294 19.75 15.6478 19.75 15.25V1.75C19.75 1.35218 19.592 0.970644 19.3107 0.68934C19.0294 0.408035 18.6478 0.25 18.25 0.25ZM1.75 10.75H3.25C3.44891 10.75 3.63968 10.671 3.78033 10.5303C3.92098 10.3897 4 10.1989 4 10C4 9.80109 3.92098 9.61032 3.78033 9.46967C3.63968 9.32902 3.44891 9.25 3.25 9.25H1.75V7.75H3.25C3.44891 7.75 3.63968 7.67098 3.78033 7.53033C3.92098 7.38968 4 7.19891 4 7C4 6.80109 3.92098 6.61032 3.78033 6.46967C3.63968 6.32902 3.44891 6.25 3.25 6.25H1.75V4.75H3.25C3.44891 4.75 3.63968 4.67098 3.78033 4.53033C3.92098 4.38968 4 4.19891 4 4C4 3.80109 3.92098 3.61032 3.78033 3.46967C3.63968 3.32902 3.44891 3.25 3.25 3.25H1.75V1.75H5.5V15.25H1.75V10.75ZM18.25 15.25H7V1.75H18.25V15.25Z"
          fill="#667085"
        />
      </svg>
    </div>
  );
};

export default SidebarIcon;
